/**
 * "The capability catalog" — Core Concepts (ADR-0074).
 * Reconciled from docs/concepts/catalog-as-authored.mdx, the CLI describe-endpoint
 * tool, and the dashboard capability-detail editor.
 */
import type { DocPageContent } from '../types';

const TERM = (k: string) => ({
  termKey: `docs.concepts.catalog.field.${k}.term`,
  descKey: `docs.concepts.catalog.field.${k}.desc`,
});

export const CATALOG_PAGE: DocPageContent = {
  slug: 'catalog',
  titleKey: 'docs.concepts.catalog.title',
  descriptionKey: 'docs.concepts.catalog.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.concepts.catalog.lead' },

    { kind: 'heading', level: 2, id: 'what', textKey: 'docs.concepts.catalog.what.heading' },
    { kind: 'paragraph', textKey: 'docs.concepts.catalog.what.body' },

    { kind: 'heading', level: 2, id: 'fields', textKey: 'docs.concepts.catalog.fields.heading' },
    {
      kind: 'definitions',
      items: [
        TERM('id'),
        TERM('route'),
        TERM('inputs'),
        TERM('description'),
        TERM('sideEffect'),
        TERM('risk'),
        TERM('scopes'),
        TERM('internal'),
        TERM('pii'),
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'authored',
      textKey: 'docs.concepts.catalog.authored.heading',
    },
    { kind: 'paragraph', textKey: 'docs.concepts.catalog.authored.body' },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.concepts.catalog.authored.note.title',
      textKey: 'docs.concepts.catalog.authored.note.body',
    },

    { kind: 'heading', level: 2, id: 'sot', textKey: 'docs.concepts.catalog.sot.heading' },
    { kind: 'paragraph', textKey: 'docs.concepts.catalog.sot.body' },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.concepts.catalog.next.browserGate.title',
          textKey: 'docs.concepts.catalog.next.browserGate.text',
          to: { docSlug: 'browser-gate' },
        },
        {
          titleKey: 'docs.concepts.catalog.next.confirmation.title',
          textKey: 'docs.concepts.catalog.next.confirmation.text',
          to: { docSlug: 'confirmation' },
        },
      ],
    },
  ],
};
